import { axios } from '@/utils/axios'

// 登录
export async function login (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/login',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 第三方授权
export async function thirdPartyOauth (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/authorize',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 第三方登录
export async function thirdPartyLogin (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/redirect/login',
      method: 'get',
      params: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 第三方公众号登录
export async function thirdPartySourceLogin (params, source) {
  try {
    return await axios({
      url: `/psg-community-user/api/oauth/login/${source}`,
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 第三方账户绑定b2c账户
export async function thirdPartyBind (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/bind/account',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 金鹏账户绑定手机
export async function ffpBind (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/ffp/bind/account',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 登出
export async function logout () {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/logout',
      method: 'get'
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 注册
export async function register (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/common/register',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 注册 - 代理人
export async function registerCompany (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/common/registerAgent',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 忘记密码-个人信息确认
export async function forgetPasswordCheckInfo (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/forget/password/checkUserOfForgetPwd',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 忘记密码-手机、邮箱验证
export async function forgetPasswordCodeVerify (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/forget/password/sms/codeVerify',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 忘记密码-密保验证
export async function forgetPasswordQuestionVerify (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/forget/password/verifySecurityQuestion',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 忘记密码-重置密码
export async function forgetPasswordReset (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/user/forget/password/reset',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 中文转拼音
export async function parseToPinyin (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/ajax/piny',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 获得系统配置（登录配置首次用）
/**
 * @params
 * code：码表
 * - member_login_config
 */
export async function getSysConfig (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/ajax/getSysConfig',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}

// 弱密码提示十天内不提醒设置
export async function loginNoRemindSet (params) {
  try {
    return await axios({
      url: '/psg-community-user/api/oauth/loginNoRemindSet',
      method: 'post',
      data: params
    })
  } catch (err) {
    return Promise.reject(err)
  }
}
